module.exports = __webpack_public_path__ + "static/media/banner-principal-mobile.be0f76c0.png";